
import { defineComponent, PropType } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

interface PortfolioItem {
  name: string;
  img: string;
  alt: string;
  date: number;
  category: string;
  link: string;
  description: string;
}

import { getImgUrl } from "@/helpers/getImage";
export default defineComponent({
  name: "PortfolioExample",
  components: { FontAwesomeIcon },

  props: {
    portfolioItem: {
      type: Object as PropType<PortfolioItem>,
      required: true,
    },
    selectedCategory: {
      type: String,
      default: "all",
    },
  },

  setup() {
    return { getImgUrl };
  },
});
